<template>
  <div>
    <v-combobox
      v-model="localValue"
      v-bind="{ ...$attrs, ...commonAttrs }"
      v-on="$listeners"
      chips
      multiple
      :items="localValue"
    >
      <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="slotData">
        <slot :name="scopedSlotName" v-bind="slotData" />
      </template>
      <template v-for="(_, slotName) in $slots" #[slotName]>
        <slot :name="slotName" />
      </template>
    </v-combobox>
    <div v-if="showSelectableOptions && selectableOptions.length > 0" class="mt-2 pb-4">
      <BaseLabel
        v-if="availableOptionsLabel"
        :label="this.availableOptionsLabel"
      />
      <MultiChip
        small
        :chips="selectableOptions"
        @click:chip="addOption"
      >
        <template #chip="{ chip }">
          <v-icon small v-if="preferredOption && preferredOption === chip">
            mdi-star
          </v-icon>
          {{ chip }}
        </template>
      </MultiChip>
    </div>
  </div>
</template>

<script>
import { difference } from 'lodash';
import localValue from '@/mixins/localValue';
import MultiChip from '@/components/MultiChip.vue';

export default {
  name: 'Combobox',
  inheritAttrs: false,
  components: {
    MultiChip,
  },
  mixins: [localValue],
  props: {
    possibleOptions: {
      type: Array,
      default: () => [],
    },
    preferredOption: {
      type: [String, Number, Boolean],
      default: undefined,
    },
    availableOptionsLabel: {
      type: String,
      default: undefined,
    },
    showSelectableOptions: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    commonAttrs() {
      return {
        hideDetails: this.$attrs.hideDetails || 'auto',
      };
    },
    selectableOptions() {
      return difference(this.possibleOptions, (this.localValue || []));
    },
  },
  methods: {
    addOption(option) {
      if (this.localValue) {
        if (!this.localValue.includes(option)) {
          this.localValue.push(option);
        }
      } else {
        this.localValue = [option];
      }
    },
  },
}
</script>